import Setting from "constants/setting";

export function getImageSrc(src, imageSize = Setting.medium) {
  return !src
    ? `/NoImages/NoImage-${imageSize}.png`
    : process.env.REACT_APP_SERVER_URL + src;
}
